import { useTranslation } from "react-i18next";

import { OrgLogoMark } from "@/features/identity-hub/components/dashboard/OrgLogoMark";

interface ClientMarkProps {
  name: string;
  logoUrl?: string | null;
  brandColor?: string | null;
  size?: "sm" | "md";
}

export function ClientMark({
  name,
  logoUrl,
  brandColor,
  size = "md",
}: ClientMarkProps) {
  const { t } = useTranslation();
  const sizePixels = size === "sm" ? 24 : 32;

  return (
    <OrgLogoMark
      name={name}
      logoUrl={logoUrl}
      logoAlt={t("marketplace.partner.clientLogoAlt", "{{name}} logo", {
        name,
      })}
      accent={brandColor}
      size={sizePixels}
      textClassName={size === "sm" ? "text-[9px]" : "text-[10px]"}
    />
  );
}
